module.exports = __webpack_public_path__ + "img/svg/ps4.3299e1bc9e6e391a6fc8b2e51f8f3d8c.svg";